let stickyContainer,
    header = document.getElementById('site-header');

if ( document.querySelector(".sticky-container") ){
  stickyContainer = document.querySelector(".sticky-container");
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  headerHeight = header.offsetHeight;

  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
      stickyContainer.classList.remove(scrollUp);
      stickyContainer.style.top = "-100%"
      return;
    }
    if (currentScroll > lastScroll && !stickyContainer.classList.contains(scrollDown)) {
      // down
      stickyContainer.classList.remove(scrollUp);
      stickyContainer.classList.add(scrollDown);
      stickyContainer.style.top = "-100%"
    } else if (
      currentScroll < lastScroll &&
      stickyContainer.classList.contains(scrollDown)
    ) {
      // up
      stickyContainer.classList.remove(scrollDown);
      stickyContainer.classList.add(scrollUp);
      stickyContainer.style.top = headerHeight + 'px';

    }

    lastScroll = currentScroll;

  });
}

/* Get the header element and it's position */
let shopHeader = document.getElementById('shopify-section-header');
let headerDiv = document.getElementById('site-header');

let scrollDirection = null;
let lastScrollY = window.pageYOffset;
let ticking = false;

const updateScrollDirection = () => {
  const scrollY = window.pageYOffset;
  const direction = scrollY > lastScrollY ? "down" : "up";

  if (scrollY === 0) {
    // If at the top of the screen, set header top to 0
    headerDiv.style.top = "0";
  } else if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
    scrollDirection = direction;
    if (scrollDirection === "up") {
      headerDiv.style.top = "0";
    } else if (scrollDirection === "down") {
      headerDiv.style.top = "-" + headerDiv.offsetHeight + "px";
    }
  }

  lastScrollY = scrollY > 0 ? scrollY : 0;
  ticking = false; // Reset the throttle flag
};

const onScrollTick = () => {
  if (!ticking) { // Only proceed if not already throttled
    window.requestAnimationFrame(updateScrollDirection); // Throttle using requestAnimationFrame
    ticking = true;
  }
};

window.addEventListener("scroll", onScrollTick);
